import React from "react";
import "./services.css";
import Reveal from "../ui/Reveal";
import { buildAreas } from "../../data/site";

/* One tiny animated glyph per area. Decorative; each hints at what the area is about. */
const GLYPHS = {
  // private learning: sites send only updates to a shared centre, raw data stays put
  privacy: (
    <>
      <circle cx="20" cy="20" r="5" className="g-fill" />
      {[
        [7, 8],
        [33, 8],
        [20, 34],
      ].map(([x, y], i) => (
        <g key={i}>
          <line x1={x} y1={y} x2="20" y2="20" className="g-flow" style={{ animationDelay: `${i * 0.4}s` }} />
          <circle cx={x} cy={y} r="3.2" className="g-ring" />
        </g>
      ))}
    </>
  ),
  // trustworthy ML: a signal line that keeps being watched
  ml: (
    <>
      <path d="M3 24 L11 24 L15 12 L21 32 L26 18 L30 24 L37 24" className="g-trace" pathLength="100" />
      <circle cx="37" cy="24" r="2.2" className="g-dot" />
    </>
  ),
  // computer vision: a frame with a scan line sweeping across it
  vision: (
    <>
      <rect x="5" y="7" width="30" height="26" rx="3" className="g-ring" />
      <circle cx="20" cy="20" r="6" className="g-ring" />
      <line x1="5" y1="20" x2="35" y2="20" className="g-scan" />
    </>
  ),
  // GPU computing: many lanes working in parallel
  hpc: (
    <>
      {[0, 1, 2, 3, 4].map((i) => (
        <rect key={i} x={5 + i * 6.5} y="8" width="4" height="24" rx="1.5" className="g-bar" style={{ animationDelay: `${i * 0.18}s` }} />
      ))}
    </>
  ),
  // developer tools: an editor bracket pair with a blinking caret
  tools: (
    <>
      <path d="M13 11 L5 20 L13 29" className="g-line" />
      <path d="M27 11 L35 20 L27 29" className="g-line" />
      <line x1="20" y1="12" x2="20" y2="28" className="g-caret" />
    </>
  ),
  // backend: a state that loops and recovers
  backend: (
    <>
      <circle cx="20" cy="20" r="13" className="g-orbit" />
      <circle cx="20" cy="7" r="3" className="g-fill" />
      <circle cx="31" cy="26" r="3" className="g-ring" />
      <circle cx="9" cy="26" r="3" className="g-ring" />
    </>
  ),
};

/** "What I build": a slim ribbon, one short line per area. */
const Services = () => (
  <section className="build" aria-labelledby="build-title">
    <div className="container">
      <h2 id="build-title" className="build__title">
        What I build
      </h2>
      <Reveal as="ul" className="build__ribbon">
        {buildAreas.map((area, i) => (
          <li key={area.domain} className="build__item" style={{ "--i": i }}>
            <svg className="glyph" viewBox="0 0 40 40" aria-hidden="true" focusable="false">
              {GLYPHS[area.domain]}
            </svg>
            <h3 className="build__name">{area.title}</h3>
            <p className="build__line">{area.line}</p>
          </li>
        ))}
      </Reveal>
    </div>
  </section>
);

export default Services;
